(function () {
  function money(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2
    }).format(amount);
  }

  function copyText(button) {
    const targetId = button.getAttribute("data-ea-copy-target");
    const target = targetId ? document.getElementById(targetId) : null;
    const text = target ? target.textContent.trim() : "";
    if (!text) return;

    const done = () => {
      const original = button.textContent;
      button.textContent = button.getAttribute("data-ea-copied-label") || "Copied";
      window.setTimeout(() => {
        button.textContent = original;
      }, 1800);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(() => {});
      return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand("copy");
      done();
    } catch (error) {
      // Clipboard support varies inside older embedded browsers.
    }
    textarea.remove();
  }

  function initCopyButtons(scope) {
    scope.querySelectorAll("[data-ea-copy-target]").forEach((button) => {
      button.addEventListener("click", () => copyText(button));
    });
  }

  function initCalculators(scope) {
    scope.querySelectorAll("[data-ea-calculator]").forEach((calculator) => {
      const input = calculator.querySelector("[data-ea-calculator-input]");
      const total = calculator.querySelector("[data-ea-calculator-total]");
      const button = calculator.querySelector("[data-ea-calculator-button]");
      if (!input || !total) return;

      const unit = Number(calculator.getAttribute("data-unit-price") || "0");
      const minimum = Number(calculator.getAttribute("data-minimum") || "1");
      const buttonTemplate = button ? button.getAttribute("data-button-template") || "" : "";

      const render = () => {
        const raw = Number(input.value || minimum);
        const count = Math.max(minimum, Number.isFinite(raw) ? raw : minimum);
        input.value = String(count);
        const calculated = count * unit;
        total.textContent = money(calculated);
        if (button && buttonTemplate) {
          button.textContent = buttonTemplate
            .replace("[Student Count]", String(count))
            .replace("[Calculated Total]", money(calculated));
        }
      };

      input.addEventListener("input", render);
      input.addEventListener("blur", render);
      render();
    });
  }

  function normalizeTopic(value) {
    return String(value || "").trim().toLowerCase().replace(/[_\s]+/g, "-");
  }

  function initTopicSelects(scope) {
    const params = new URLSearchParams(window.location.search);
    const topic = normalizeTopic(params.get("topic") || params.get("interest"));
    if (!topic) return;

    scope.querySelectorAll("[data-ea-topic-select]").forEach((select) => {
      const option = Array.from(select.options).find((candidate) => normalizeTopic(candidate.value) === topic);
      if (option) select.value = option.value;
    });
  }

  function initClassPackProduct(scope) {
    const helper = scope.querySelector("[data-ea-class-pack-helper]");
    if (!helper) return;
  }

  function init() {
    initCopyButtons(document);
    initCalculators(document);
    initTopicSelects(document);
    initClassPackProduct(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
